import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "None of the advisers on our panel would recommend a transfer to someone who the FCA believes that a transfer is highly unlikely to be suitable for.")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "If you require help with future retirement planning;")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" If you want further guidance and planning tools, to help you see how to use your current scheme benefits (and anything else you have) for retirement planning, you can use our retirement planning site "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://adviser.guiide.co.uk",
    target: "_blank"
  }, "www.adviser.guiide.co.uk"),
  /*#__PURE__*/_createTextVNode(" at no cost. ")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, " These tools may provide everything you need, but if you need advice on future retirement planning it will also signpost you to our general retirement adviser panel if you wish to seek this. ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, " To be clear any adviser shown will not provide advice on a defined benefit transfer, only general retirement planning advice. ")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "We would not recommend a transfer to someone who the FCA believes that a transfer is highly unlikely to be suitable for.")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" If you still wish to seek advice on a potential transfer you can visit the "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.moneyhelper.org.uk/en",
    target: "_blank"
  }, "MoneyHelper"),
  /*#__PURE__*/_createTextVNode(" site for further guidance and signposting to an adviser. ")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "We can provide advice on general retirement planning.")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, " If you no longer wish to consider a transfer, you may wish to seek advice on using your current scheme benefits (and anything else you have) to provide your retirement income. ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "If so, click below and we can show how we can help.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_nav_buttons = _resolveComponent("nav-buttons")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($options.showGuiide)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_1,
          _hoisted_2,
          _hoisted_3,
          _hoisted_4,
          _hoisted_5
        ], 64))
      : _createCommentVNode("", true),
    ($options.showOrigen)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          _hoisted_9,
          _hoisted_10,
          _createVNode(_component_nav_buttons, {
            previousVisible: false,
            nextVisible: true,
            nextText: $options.showAdvisorsText,
            onNextClicked: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('show-retirement-advisors-required')))
          }, null, 8, ["nextText"])
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}